import { Component, OnInit, Input } from '@angular/core';
import { PayService } from '../../invoices/pay.service';
import { PopoverController } from '@ionic/angular';
import { DialogService } from '../../_services';

@Component({
  selector: 'invoice-pay-select-vids',
  templateUrl: './invoice-pay-select-vids.component.html',
})
export class InvoicePaySelectVidsComponent implements OnInit {
  @Input() payModel;
  @Input() payData;
  @Input() scfField;
  parseFloat = parseFloat;
  totalVidsSelected = 0;
  selectedVidAmt = 0;
  vidList = [];
  filteredVidList = [];
  showAmountError = false;
  showAmountExceedError = false;
  deductionAmount = '0';
  filterVIDText = '';
  constructor(
    private payService: PayService, 
    private modal: PopoverController, 
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.deductionAmount = this.payModel[this.scfField.key];
    this.getVIDsData();
  }

  getVIDsData() {
    this.payService.getVIDsForInvoice(this.payData).subscribe(data => {
      this.vidList = data;
      this.getFilteredVidList();
      const vidsSelectedForField = this.scfField.vidsSelected || [];
      this.vidList.forEach(vid => {
        vid.selected = false;
        if (vidsSelectedForField && vidsSelectedForField.length) {
          vid.selected = vidsSelectedForField.filter(selectedVid => selectedVid.id === vid.id).length > 0;
        }
      })
      this.getVIDSelectionCount();
    });
  }

  setVidSelection(vid) {
    vid.selected = !vid.selected;
    this.getVIDSelectionCount();
    if (!this.totalVidsSelected) {
      this.deductionAmount = '0';
    }
  }

  private getVIDSelectionCount() {
    this.totalVidsSelected = 0;
    this.selectedVidAmt = 0;
    this.vidList.forEach(vid => {
      if(vid.selected) {
        this.totalVidsSelected += 1;
        this.selectedVidAmt += parseFloat(vid.amt);
      }
    })
  }

  formIsInValid() {
    if (parseFloat(this.deductionAmount) >= this.payData.invoiceData.BA) {
      this.showAmountError = true;
      this.showAmountExceedError = false;
      return true;
    } else if(this.vidList.length && (parseFloat(this.deductionAmount) > this.selectedVidAmt)) {
      this.showAmountError = false;
      this.showAmountExceedError = true;
      return true;
    } else {
      this.showAmountError = false;
      this.showAmountExceedError = false;
    }
    if ((!this.totalVidsSelected && this.vidList.length) || parseFloat(this.deductionAmount) <= 0) {
      return true;
    } else {
      return false;
    }
  }
  

  close(setAmount = false) {
    if (setAmount) {
      if (!this.formIsInValid()) {
        this.scfField.vidsSelected = this.vidList.filter(vid => vid.selected);
        this.payModel[this.scfField.key] = this.deductionAmount;
      }
    }
    this.modal.dismiss();
  }

  getFilteredVidList() {
    this.filteredVidList = this.vidList.filter(item => {
      if(!this.filterVIDText) {
        return true;
      }
      if (item.searchKey) {
        return item.searchKey.toLowerCase().indexOf(this.filterVIDText.toLowerCase()) !== -1;
      } else {
        return false;
      }
    });
  }

}
